import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { Carousel } from 'react-responsive-carousel';
import { intervalTime, transitionTime } from '../../../config/setup/setup';
import ThemeContext from '../../../providers/ThemeProvider';
import SecondaryDealBuyAgain from '../SecondaryDealBuyAgain';
import SecondaryDeal from '../secondaryDeal';

const CarouselArrow = dynamic(() => import('./carousel-common/CarouselArrow'), {
  ssr: false,
});

const CarouselDealBlock = ({ deals }) => {
  const theme = useContext(ThemeContext);

  if (deals.length === 0) {
    return null;
  }

  return (
    <>
      <Carousel
        autoPlay
        className="carousel-deal"
        emulateTouch
        infiniteLoop
        interval={intervalTime}
        renderArrowNext={(onClickHandler, hasNext, label) => (
          <CarouselArrow
            isOffset
            label={label}
            onClickHandler={onClickHandler}
            orientation="next"
          />
        )}
        renderArrowPrev={(onClickHandler, hasPrevious, label) => (
          <CarouselArrow
            isOffset
            label={label}
            onClickHandler={onClickHandler}
            orientation="prev"
          />
        )}
        showIndicators={false}
        showStatus={false}
        showThumbs={false}
        swipeable
        transitionTime={transitionTime}
      >
        {deals?.map((deal) => {
          const isBuyAgainDeal = deal?.promoType?.title === 'Buy again';

          return isBuyAgainDeal ? (
            <SecondaryDealBuyAgain
              deal={deal}
              earlyBird
              extraclasses="full-width small-deal card no-card"
              hasSocialCueTop={false}
              isXS
              key={deal.id}
              ppNotVisible
            />
          ) : (
            <SecondaryDeal
              deal={deal}
              earlyBird
              extraclasses="full-width small-deal card no-card"
              hasSocialCueTop={false}
              isXS
              key={deal.id}
              ppNotVisible
            />
          );
        })}
      </Carousel>
      <style global jsx>{`
        .carousel-deal {
          border-radius: 10px;
          overflow: hidden;
          box-shadow: 0 2px 5px ${theme.colors.dropshadow};
          padding: 0;
          /* fix for safari rounded overflow hidden bug https://stackoverflow.com/a/16681137 */
          backface-visibility: hidden;
          transform: translate3d(0, 0, 0);
        }
        .carousel-deal :global(.carousel .slide) {
          background: transparent;
        }
        @media (max-width: ${theme.breakpoints.smDown}) {
          .carousel-deal {
            border-radius: 0;
            box-shadow: none;
          }
        }
        .carousel-deal :global(.deal-image__container) {
          position: static;
        }
      `}</style>
    </>
  );
};

CarouselDealBlock.propTypes = {
  deals: PropTypes.array,
};

CarouselDealBlock.defaultProps = {
  deals: {},
};
export default CarouselDealBlock;
